module.exports = __webpack_public_path__ + "static/media/truck_6t.0d48458c.svg";